export default __webpack_public_path__ + "static/media/proto-chain.3ed5f3ea.png";